import {
    Button,
    Divider,
    Grid2,
    Icon,
    IconButton,
    InputBase,
    Paper
} from '@mui/material';
import { useEffect, useState } from 'react';

import { ValidatorForm } from 'react-material-ui-form-validator';
import { IDropdownData } from '../../../_common/interface/dropdown/iDropdownData.interface';
import { StandardButton } from '../../../_components/button/primary.button';
import { toastr } from '../../../_components/toastr/toastr';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { auctionMessageService } from '../../../_services/auctionMessage.service';
import AuctionNotificationType from './auction-notificationType';
import AuctionUsersDropdown from './auction-usersDropdown';
import AuctionDefaultMessageDropdown from './auction-defaultMessageDropdown';

export function AuctionChat(params: { auctionId: number, catalogueId: number }) {

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ message: "", messageSeverityId: null, catalogueUserId: null });

    const [catalogueUser, setAuctionUser] = useState<IDropdownData | null>(null);
    const [messageSeverityId, setMessageSeverityId] = useState<number | null>(null);

    function handleChange(event: any) {
        setMessage((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    useEffect(() => {
        if (!!params.catalogueId)
            setLoading(false);
    }, [params.catalogueId]);

    function create() {
        if (!params.catalogueId) return;

        setLoading(true);

        return auctionMessageService.post(params.auctionId, params.catalogueId, message.message, messageSeverityId, catalogueUser?.id)
            .then(
                data => {
                    setMessage({ message: "", messageSeverityId: null, catalogueUserId: null });
                    setAuctionUser(null)
                    setMessageSeverityId(null);
                    toastr.success("Message posted")
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Paper style={{ "padding": "4px" }}>
            <ValidatorForm
                onSubmit={(e) => {
                    e.preventDefault();
                    if (message.message)
                        create();
                }}
                noValidate>

                <Grid2 container spacing={1}>
                    <Grid2 size={{ xs: 12 }}>
                        <InputBase
                            fullWidth
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Type Auction Notification"
                            inputProps={{ 'aria-label': 'type notification' }}
                            name="message"
                            value={message.message}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 2 }}>
                        <AuctionDefaultMessageDropdown onChange={(d: any) => {
                            if (!d) return;
                            setMessage((m: any) => ({ ...m, message: d.name, messageSeverityId: d.messageSeverityId }))
                            setMessageSeverityId(d.messageSeverityId)
                        }} />
                    </Grid2>
                    <Grid2 size={{ xs: 2 }}>
                        <AuctionNotificationType
                            messageSeverityId={messageSeverityId}
                            setMessageSeverityId={setMessageSeverityId}
                            onChange={(messageSeverityId) => { setMessage((m: any) => ({ ...m, messageSeverityId: messageSeverityId })) }} />
                    </Grid2>
                    <Grid2 size={{ xs: 3 }}>
                        <AuctionUsersDropdown style={{ "height": "24px", width: "100%" }} catalogueUser={catalogueUser} setAuctionUser={setAuctionUser} catalogueId={params.catalogueId} onChange={(d) => {
                            setMessage((m: any) => ({ ...m, catalogueUserId: d }))
                        }} />
                    </Grid2>
                    <Grid2 size={{ xs: 5 }}>
                        <Button type="submit" sx={{ p: '16px' }} fullWidth variant='contained' color='success' aria-label="search" endIcon={<Icon>send</Icon>}>
                            SEND
                        </Button>
                    </Grid2>
                </Grid2>








                {/* <StandardButton
                icon="save"
                type="submit">
                Save
            </StandardButton> */}



            </ValidatorForm>
        </Paper>
    )
}
